"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fossalta-di-portogruaro": {
    "5a2b0000": [{
      "hkey": "169640ac",
      "slug": "villanova-sant-antonio-sacilato",
      "name": "Villanova Sant'Antonio-Sacilato",
      "primary": true,
      "skipSearch": false
    }],
    "sacilato": [{
      "hkey": "169640ac",
      "slug": "villanova-sant-antonio-sacilato",
      "name": "Villanova Sant'Antonio-Sacilato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fossalta-di-portogruaro"
    }],
    "9b75ff73": [{
      "hkey": "43fc62c1",
      "slug": "fossalta-di-portogruaro",
      "name": "Fossalta di Portogruaro",
      "primary": true,
      "skipSearch": false
    }],
    "torressella": [{
      "hkey": "43fc62c1",
      "slug": "fossalta-di-portogruaro",
      "name": "Fossalta di Portogruaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6b5f547": [{
      "hkey": "169640ac",
      "slug": "villanova-sant-antonio-sacilato",
      "name": "Villanova Sant'Antonio-Sacilato",
      "primary": true,
      "skipSearch": false
    }],
    "villanova-sant-antonio": [{
      "hkey": "169640ac",
      "slug": "villanova-sant-antonio-sacilato",
      "name": "Villanova Sant'Antonio-Sacilato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2e2fc874": [{
      "hkey": "a9aa5de3",
      "slug": "fratta-gorgo",
      "name": "Fratta-Gorgo",
      "primary": true,
      "skipSearch": false
    }],
    "fratta": [{
      "hkey": "a9aa5de3",
      "slug": "fratta-gorgo",
      "name": "Fratta-Gorgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f5f21de5": [{
      "hkey": "a9aa5de3",
      "slug": "fratta-gorgo",
      "name": "Fratta-Gorgo",
      "primary": true,
      "skipSearch": false
    }],
    "gorgo": [{
      "hkey": "a9aa5de3",
      "slug": "fratta-gorgo",
      "name": "Fratta-Gorgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fossalta-di-portogruaro"
    }]
  }
};
exports["default"] = _default;